import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'

import {accountInformationTypecheck} from '@/auth/model'
import ParseError from '@/utils/errors/ParseError'
import {logError} from '@/utils/logger'

export default function parseAccountInformation(accountBase64: string) {
  try {
    const accountRaw = Base64.parse(accountBase64).toString(Utf8)
    const newAccount = JSON.parse(accountRaw)

    if (!accountInformationTypecheck.Check(newAccount)) {
      console.error('Account is invalid', ...accountInformationTypecheck.Errors(newAccount))
      logError(
        new ParseError(
          'Account',
          'Account is invalid',
          Array.from(accountInformationTypecheck.Errors(newAccount)),
        ),
      )
      return
    }

    return newAccount
  } catch (e) {
    logError(e)
  }
}
